module.exports = __webpack_public_path__ + "static/media/LinkedIn_Symbol_0.4242f0d4.svg";